import React from "react";
import { HStack, Text } from "@chakra-ui/react";
import { ArrowDown, ArrowUp } from "@phosphor-icons/react";

// Year-over-year delta lozenge: green when emissions/intensity went down
// (improvement), red when up (worse). Returns null when there's no
// meaningful comparison (no previous data, divide by zero).
function YoYChip({ pctChange, size = "sm" }) {
  if (pctChange == null || !Number.isFinite(pctChange)) return null;

  const isImprovement = pctChange < 0;
  const bg = isImprovement ? "green.50" : "red.50";
  const color = isImprovement ? "green.700" : "red.600";
  const Arrow = isImprovement ? ArrowDown : ArrowUp;
  const fontSize = size === "lg" ? "12px" : "11px";
  const iconSize = size === "lg" ? 12 : 11;

  return (
    <HStack
      spacing={1}
      bg={bg}
      color={color}
      px={2}
      py={0.5}
      borderRadius="full"
      flexShrink={0}
      w="fit-content"
    >
      <Arrow size={iconSize} weight="bold" />
      {/* Non-breaking space before % so the label can never fold onto a
          second line when the chip is in a tight table cell. */}
      <Text fontSize={fontSize} fontWeight="600" whiteSpace="nowrap">
        {Math.abs(pctChange).toFixed(1)}&nbsp;%
      </Text>
    </HStack>
  );
}

export default YoYChip;
